// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#view-root[data-v-52c7157a]{display:flex;justify-content:center;align-items:center;margin-top:30px}#form[data-v-52c7157a]{width:30%;display:flex;flex-direction:column}button[data-v-52c7157a]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
